/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountFeatureFlagsListParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
    limit: zod.number().optional(),
    order: zod.string().optional(),
    page: zod.number().optional(),
});

export type ApiAccountFeatureFlagsListParams = zod.input<
    typeof ApiAccountFeatureFlagsListParams
>;
export type ApiAccountFeatureFlagsListParamsOutput = zod.output<
    typeof ApiAccountFeatureFlagsListParams
>;
